import { Button } from '@toggle/design-system';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigateToAssetOverview } from '~/hooks/use-navigate-to-asset-overview/useNavigateToAssetOverview';
import { TabsType } from '~/modules/tab-content/types';
import { DownloadButton } from '~/views/stream/components/download-button/DownloadButton';
import { handleDownloadDrawer } from '~/views/stream/utils/handleDownloadDrawer';

import { EarningsInsightWidget } from './earnings-insight-widget/EarningsInsightWidget';
import * as S from './EarningsInsightDrawer.styles';
import { useEarningsInsightDrawer } from './useEarningsInsightDrawer';

export const EarningsInsightDrawer = () => {
  const { t } = useTranslation(['earnings', 'common', 'chat', 'widget']);
  const { navigateToPage } = useNavigateToAssetOverview();

  const [expandCitations, setExpandCitations] = useState(false);

  const contentWrapperRef = useRef<HTMLDivElement>(null);

  const { isDrawerOpen, closeDrawer, activeEntityTag } =
    useEarningsInsightDrawer();

  const handleDownload = () => {
    if (contentWrapperRef.current) {
      handleDownloadDrawer({
        contentToPrint: contentWrapperRef.current,
        entityTag: activeEntityTag,
        expandAccordions: setExpandCitations,
      });
    }
  };

  if (!activeEntityTag) {
    return null;
  }

  return (
    <S.StyledDrawer
      data-testid="earnings-insight-drawer"
      isOpen={isDrawerOpen}
      handleCloseClick={closeDrawer}
      headerButton={
        <S.HeaderButtons>
          <Button
            variant="empty"
            label={t('earnings:earningsInsight.drawer.viewOnAO')}
            iconName="Expand"
            size="xsmall"
            onClick={() =>
              navigateToPage({
                entityTag: activeEntityTag,
                tab: TabsType.Earnings,
              })
            }
          />
          <DownloadButton onClick={handleDownload} />
        </S.HeaderButtons>
      }
    >
      <S.ContentWrapper ref={contentWrapperRef}>
        <EarningsInsightWidget expandCitations={expandCitations} />
      </S.ContentWrapper>
    </S.StyledDrawer>
  );
};
